import { ROUTE_ROOT } from '@/models/Route';
import { getLandingState, getMainUserState } from '@/modules/main/selector';
import { NoticeProps } from '@/modules/popup/notice/NoticePopup';
import { RootState } from '@/store/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useCurrentTime } from './useCurrentTime';
import { useGameFeature } from './useGameFeature';

const currentNotice = {
    id: 'notice_abc',
    lastDay: 1737374400000,
    haveTitle: false,
    imageLang: ['id-ID', 'ko-KR', 'ms-MY', 'th-TH', 'vi-VN', 'zh-CN', 'zh-TW'],
} as NoticeProps;
const READ_STRING = 'read';
export const useNotice = () => {
    const location = useLocation();
    const [haveNotice, setHaveNotice] = useState<boolean>(false);
    const { lobby } = useSelector((state: RootState) => getLandingState(state));

    const { isAutoConfirmEnabled } = useGameFeature();
    const { currentTimeStamp } = useCurrentTime();
    const { Username } = useSelector(getMainUserState);
    const closeNotice = () => {
        setHaveNotice(false);
        if (isAutoConfirmEnabled) {
            localStorage.setItem(currentNotice.id + Username, READ_STRING);
        }
    };
    useEffect(() => {
        if (Username) {
            if (lobby !== 'trial') {
                if (location.pathname !== ROUTE_ROOT) {
                    const read =
                        localStorage.getItem(currentNotice.id + Username) ===
                        READ_STRING;
                    if (
                        !read &&
                        isAutoConfirmEnabled &&
                        currentTimeStamp() < currentNotice.lastDay
                    ) {
                        setHaveNotice(true);
                    } else {
                        if (isAutoConfirmEnabled) {
                            localStorage.setItem(
                                currentNotice.id + Username,
                                READ_STRING
                            );
                        }
                    }
                }
            } else {
                setHaveNotice(false);
            }
        }
    }, [isAutoConfirmEnabled, Username, location, lobby]);
    return { haveNotice, currentNotice, closeNotice };
};
